import { useMemo } from "react";

import Grid from "@mui/material/Grid";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { LoadingOrValue } from "@covertree/ui";
import { formatAwsDateString } from "@covertree/utils";

import { PolicyDetailsContentProps } from "../../../types";

export function RepresentativeDetails({
  policy,
  loading,
}: PolicyDetailsContentProps) {
  const {
    policyholder: { firstName, lastName, repRelationToOrg },
    insuredDateOfBirth,
  } = policy;

  const representativeName = useMemo(
    () => `${firstName} ${lastName}`,
    [firstName, lastName]
  );

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Representative",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={representativeName}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
          },
          {
            label: "Rep date of birth",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatAwsDateString(insuredDateOfBirth)}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
          },
          {
            label: "Relation to organization",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={repRelationToOrg}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
          },
        ]}
      />
    </Grid>
  );
}
